import './UserInfo.css'

function UserInfo({ user }) {
  if (!user) return null

  return (
    <div className="card user-info">
      <h2>Informasi User</h2>
      <div className="user-details">
        <div className="detail-item">
          <span className="label">User ID:</span>
          <span className="value">{user.id}</span>
        </div>
        <div className="detail-item">
          <span className="label">Nama:</span>
          <span className="value">
            {[user.first_name, user.last_name].filter(Boolean).join(' ') || 'N/A'}
          </span>
        </div>
        {user.username && (
          <div className="detail-item">
            <span className="label">Username:</span>
            <span className="value">@{user.username}</span>
          </div>
        )}
        {user.language_code && (
          <div className="detail-item">
            <span className="label">Bahasa:</span>
            <span className="value">{user.language_code.toUpperCase()}</span>
          </div>
        )}
        {user.is_premium && (
          <div className="detail-item">
            <span className="label">Premium:</span>
            <span className="value premium">✓ Ya</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default UserInfo

